'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import * as Icons from 'lucide-react';
import { converters } from '@/lib/converters';
import { categories } from '@/lib/data/categories';
import { LucideIcon, ChevronDown, ChevronUp } from 'lucide-react';

export function AllConvertersCard() {
  const [isExpanded, setIsExpanded] = useState(false);

  const getCategoryName = (converterId: string) => {
    const category = categories.find(cat => 
      cat.converters.includes(converterId)
    );
    return category?.name || 'General Converters';
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border p-6 flex flex-col relative overflow-hidden transition-all duration-500">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2">
          <Icons.LayoutGrid className="w-5 h-5 text-emerald-600" />
          A to Z Index
        </h2>
      </div>

      <div className={`flex flex-wrap gap-2 transition-all duration-500 overflow-hidden ${isExpanded ? 'max-h-[5000px]' : 'max-h-[400px]'}`}>
        {Object.entries(converters).map(([id, converter]) => {
          const IconComponent = Icons[converter.icon as keyof typeof Icons] as LucideIcon | undefined;
          const category = categories.find(cat => cat.converters.includes(id));
          const categorySlug = category?.name.toLowerCase().replace(/\s+/g, '-');
          const converterSlug = converter.name.toLowerCase().replace(/\s+/g, '-');

          return (
            <Link 
              href={categorySlug ? `/${categorySlug}/${converterSlug}` : '#'} 
              key={id} 
              className="group"
            >
              <div className="px-3 py-2 border rounded-xl bg-gray-50 group-hover:bg-emerald-50 group-hover:border-emerald-100 flex items-center gap-2 transition-all">
                {IconComponent && <IconComponent className="w-3.5 h-3.5 text-gray-400 group-hover:text-emerald-600" />}
                <span className="text-xs font-semibold text-gray-600 group-hover:text-emerald-700">{converter.name}</span>
              </div>
            </Link>
          );
        })}
      </div>

      {!isExpanded && (
        <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent pointer-events-none" />
      )}

      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="mt-4 w-full py-3 bg-gray-50 hover:bg-emerald-50 text-emerald-600 rounded-xl font-bold text-xs flex items-center justify-center gap-2 transition-all group"
      >
        {isExpanded ? (
          <>
            Show Less <ChevronUp className="w-4 h-4 transition-transform group-hover:-translate-y-0.5" />
          </>
        ) : (
          <>
            View All {Object.keys(converters).length} Converters <ChevronDown className="w-4 h-4 transition-transform group-hover:translate-y-0.5" />
          </>
        )}
      </button>
    </div>
  );
}
